import { render, staticRenderFns } from "./WebsiteGoodsGatherList.vue?vue&type=template&id=3bc9142f&scoped=true&"
import script from "./WebsiteGoodsGatherList.vue?vue&type=script&lang=js&"
export * from "./WebsiteGoodsGatherList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc9142f",
  null
  
)

export default component.exports